<script setup lang="ts">
  import { computed } from 'vue';
  import type { CompiledImageNode } from '@record-fill';
  import { useElementContainerStyles } from '../../model/useElementContainerStyles';
  import { useImageDisplay } from '../../model/useImageDisplay';

  const props = defineProps<{ node: CompiledImageNode }>();

  const { containerStyles } = useElementContainerStyles(computed(() => props.node.element.properties));
  const { displayUrl, handleImageError } = useImageDisplay(() => props.node.source);

  const altText = computed(() => {
    const label = props.node.element.properties.label?.trim();
    if (label) return label;
    return props.node.source.kind === 'url' ? 'Imagem' : 'Logo';
  });
</script>

<template>
  <div
    v-if="node.visible"
    class="flex h-full w-full items-center justify-center [font-family:var(--font-base)]"
    :style="containerStyles"
    :data-testid="`fill-image-${node.id}`"
  >
    <img
      v-if="displayUrl"
      :src="displayUrl"
      :alt="altText"
      class="max-h-[100px] max-w-full object-contain"
      @error="handleImageError"
    >
  </div>
</template>
